module.exports = {
  DEFAULT_NS: "::DEFAULT",
};
